import { render } from "./CheckboxText.vue?vue&type=template&id=493180ae&scoped=true"
import script from "./CheckboxText.vue?vue&type=script&lang=js"
export * from "./CheckboxText.vue?vue&type=script&lang=js"

import "./CheckboxText.vue?vue&type=style&index=0&id=493180ae&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493180ae"]])

export default __exports__